import "reflect-metadata"; // Must be first for tsyringe to work correctly!
import "../global";
import { DataSyncLibEventNames } from "../shared/DataSyncLibEventNames";
import { ToutvLib } from "../toutv/ToutvLib";
import { container } from "tsyringe";
import { registerToutvServices } from "../toutv/ServiceRegistration";
import { Logger } from "../utils/Logger";
import addBlueConicScript from "../cdp/AddBlueConicScript";
import { ToutvSiteSettings } from "../toutv/ToutvSiteSettings";

/** Entry point for sites under the tou.tv domain. */
if (typeof window.gtmDataSyncLib === "undefined") {
  const settings = new ToutvSiteSettings();
  registerToutvServices();
  addBlueConicScript(settings.BlueConicProductionHostName, settings.ProductionHostNames);
  Logger.LogEnvironmentMode();
  window.gtmDataSyncLib = container.resolve(ToutvLib);
  window.dispatchEvent(new Event(DataSyncLibEventNames.LibraryLoaded));
} else {
  Logger.warn("Warning: attempted double load of the library.");
}
